export const UsersListingMutations = {
  SetUsersLoading: 'setUsersLoading',
  SetUsersList: 'setUsersList',
  SetUsersSortOrder: 'setUsersSortOrder',
  SetUsersPaginationParameters: 'setUsersPaginationParams',
  ResetUsersPaginationOffset: 'resetPaginationOffset',
  SetUsersRecordCount: 'setUsersRecordCount',
  SetUsersActiveInactive: 'setUsersActiveInactive',
  SetSearchParam: 'setSearchParam'
};

export const UsersListingActions = {
  RetrieveUsers: 'updateUsersList',
  UsersSortOrder: 'updateUsersSortOrder',
  SetUsersPaginationParameters: 'updateUsersPaginationParams',
  SetUsersActiveInactive: 'updateUsersActiveField',
  RetrieveUsersRecordCount: 'updateUsersRecordCount',
  ExportAllUsers: 'exportAllUsers',
  ExportThisPage: 'exportThisPageUsers',
  UpddateSearchList: 'updateSearchList'
};

export const UsersListingGetters = {
  UsersList: 'getUsersList',
  UsersPerPage: 'getUsersPerPage',
  UsersListingOffset: 'getUsersListingOffset',
  UsersRecordCount: 'getUsersRecordCount',
  UsersActiveInactive: 'getUsersActiveInactive',
  SortBy: 'getUsersListingSortBy ',
  SortDirection: 'getUsersListingSortDirection'
};
